/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import * as React from 'react';
import { Dispatch, SetStateAction } from 'react';
import { Calendar } from 'react-calendar'
import { Checkbox} from '@vaisala/rockhopper-components';

import 'react-calendar/dist/Calendar.css';
import './calendar-style.css';

interface Props {
    disable : boolean;
    dates : string[];
    hist_nc_status : boolean[];
    onClickDay? : (date : Date) => void;
    minDate : string;
    maxDate : string;
    currentDate : string;
    new_dates? : string[];
    new_nc_status? : boolean[];
    checkbox_values? : boolean[];
    setCheckboxValues? : Dispatch<SetStateAction<boolean[] | undefined>>
}

export const NCFilesCalendar : React.FC<Props> = (props) => {
    
    const {
        disable, 
        dates,
        minDate,
        maxDate,
        currentDate,
        onClickDay,
        new_dates,
        hist_nc_status,
        new_nc_status,
        checkbox_values,
        setCheckboxValues,
    } = props

    return (
        disable? <Calendar tileDisabled={({date, view}) => true}/> :
        <Calendar

            minDate={new Date(minDate+"T00:00:00")}
            maxDate={new Date(maxDate+"T00:00:00")}
            defaultActiveStartDate={currentDate === "" ? new Date() : new Date(currentDate+"T00:00:00")}
            defaultValue={currentDate === "" ? new Date() : new Date(currentDate+"T00:00:00")}
            tileDisabled={
                ({ date, view }) => {
                    let index : number = dates.findIndex(dt => (new Date(dt+"T00:00:00")).getTime() === date.getTime());
                    let index_new : number = new_dates?.findIndex(dt => (new Date(dt+"T00:00:00")).getTime() === date.getTime())??-1;
                    return (view === 'month' && (index === -1) && (index_new === -1));
                }
            }
            tileContent={
                ({ date, view }) => {
                    let index : number = dates.findIndex(dt => (new Date(dt+"T00:00:00")).getTime() === date.getTime());
                    let index_new : number = (new_dates?.findIndex(dt => (new Date(dt+"T00:00:00")).getTime() === date.getTime()))??-1;
                    return (view === 'month' && (index >= 0 || index_new >= 0)) ?
                    <div style={{display: 'inline'}}>
                        <div className={ (index >= 0) ? (hist_nc_status[index]?'bar valid':'bar warning') : 'bar'}/>
                        {
                            (index_new >= 0 && (checkbox_values !== undefined) && (setCheckboxValues !== undefined) && new_nc_status !== undefined)?
                            <Checkbox checked={checkbox_values[index_new]} onChange={() => {
                                const new_checkbox_values = [...checkbox_values];
                                new_checkbox_values[index_new] = !new_checkbox_values[index_new];
                                setCheckboxValues(new_checkbox_values);
                                return;
                            }}/>:null
                        }
                    </div>
                    : null;
                }
            }
            onClickDay={onClickDay?
                (date) => {
                    onClickDay(date);
                } :
                undefined
            }
        />
    );
};